module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_1.6bb02d16.png";